import { render, staticRenderFns } from "./reg-2-mobile.vue?vue&type=template&id=4732b958&lang=pug&"
import script from "./reg-2-mobile.vue?vue&type=script&lang=js&"
export * from "./reg-2-mobile.vue?vue&type=script&lang=js&"
import style0 from "./reg-2-mobile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports